import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 16 16",
  class: "th-icon"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "currentColor",
      d: "M4.694 7h6.613c.279 0 .434-.323.26-.542L8.26 2.325a.333.333 0 0 0-.52 0L4.433 6.458a.333.333 0 0 0 .26.542M11.307 9H4.693a.333.333 0 0 0-.26.542l3.306 4.133a.333.333 0 0 0 .52 0l3.307-4.133a.333.333 0 0 0-.26-.542"
    }, null, -1)
  ]))]))
}
import { markRaw } from 'vue'
export default markRaw({ render: render })